import BackPageHeading from "components/BackPageHeading.component";
import { ReadOnlyWhenRestricted } from "components/capability";
import { AdminCapability } from "shared/utils/capabilities";
import { PaymentMethodsCard } from "pages/settings/PaymentMethodsCard.component";
import PATHS from "shared/constants/paths";
import { translate } from "shared/languages";

// Pengaturan -> Metode Pembayaran, reached from a tile on the Pengaturan
// launcher. Mirrors LoyaltyProgramPage.tsx's thin-wrapper shape: page chrome
// here, the actual card (list + add/edit/delete) unchanged in
// PaymentMethodsCard.component.tsx.
const PaymentMethodsPage = () => {
  return (
    <>
      <BackPageHeading
        title={translate("paymentMethods.card_title")}
        backTo={PATHS.SETTINGS}
      />
      <ReadOnlyWhenRestricted capability={AdminCapability.OperationalSettings}>
        <PaymentMethodsCard />
      </ReadOnlyWhenRestricted>
    </>
  );
};

export default PaymentMethodsPage;
